import { createSelector } from 'reselect';

import { RootState } from '../store';

import { AuthState } from './auth.reducer';

export const selectAuthReducer = (state: RootState): AuthState => state.auth;

export const selectAccessToken = createSelector(
    selectAuthReducer,
    (user) => user.accessToken
);